export class ManualCheckLoader {

  constructor ($store, { id, apiResponse }) {
    this.$store = $store || {}
    this.id = id || null
    this.apiResponse = apiResponse || []
  }

  async fetchManualChecks () {
    try {
      // Get the AP lines from apiResponse and put them in an array
      let apLines = []
      apLines = this.getReconcilableApLines(apLines)
      apLines = this.getAttachedApLines(apLines)

      // Get AP ids only and remove duplicates
      const uniqueApIds = [...new Set(apLines.map(line => line.transaction_id))]

      // Out of these APs, fetch the ones for which the payment type is 'MANUAL_CHECK'
      if (uniqueApIds.length) {
        const aps = await this.$store.dispatch('fetchApsWithQuery', {
          id__in: uniqueApIds,
          payment_confirmation_number__isnull: 'False'
        })
        // Get additonal pages, if necessary
        if (aps && aps.count > 20) {
          let page = 2
          let pageRequests = []
          const pagesNeeded = Math.ceil(aps.count / 20)
          while (page <= pagesNeeded) {
            pageRequests.push(this.$store.dispatch('fetchApsWithQuery', {
              id__in: uniqueApIds,
              payment_confirmation_number__isnull: 'False',
              page
            }))
            page++
          }
          await Promise.all(pageRequests)
        }
      }
    } catch (e) {
      console.log(e)
      return e
    }
  }

  getReconcilableApLines (apLines) {
    const reconcilable = this.apiResponse.find(resp => resp.type === 'lines/ap')
    if (reconcilable && reconcilable.entities && reconcilable.entities.length) {
      apLines = [...apLines, ...reconcilable.entities]
    }
    return apLines
  }

  getAttachedApLines (apLines) {
    const attached = this.apiResponse.find(resp => resp.type === 'ap')
    if (attached && attached.entities && attached.entities.lines) {
      apLines = [...apLines, ...Object.values(attached.entities.lines)]
    }
    return apLines
  }
}



// WEBPACK FOOTER //
// ./src/components/Programs/BankRecon/ManualCheckLoader.js